import '../css/main.scss'
import '../css/map.scss'
import './common'
// import '../node_modules/@fortawesome/fontawesome-free/js/all'

import {
  hideDetails,
  highlightFeature, MODE_CITIES_GROUPS, MODE_DEPARTMENTS, MODE_REMPLACEMENT_AREAS,
  revertFeatureStyle, toggleDNP, setInitialState, setMode, displayStreetView, setREPFilter
} from './map'

window.suv = {
  setInitialState,
  toggleDNP,
  setMode,
  setREPFilter,
  hideDetails,
  highlightFeature,
  revertFeatureStyle,
  displayStreetView,
  mode: {
    CITIES_GROUPS: MODE_CITIES_GROUPS,
    DEPARTMENTS: MODE_DEPARTMENTS,
    REMPLACEMENT_AREAS: MODE_REMPLACEMENT_AREAS,
  }
}